import React, { useEffect, useState } from 'react';
import { Image, Text, View } from 'react-native';
import { Defs, LinearGradient, Stop } from 'react-native-svg';
import { PieChart } from "react-native-svg-charts";
import { FormattedMessage } from 'react-intl';

import Button from '../../components/Button';
import HeaderDefault from "../../components/HeaderDefault";

import AsyncStorage from '@react-native-async-storage/async-storage';

import api from '../../services/api';

import styles from "./styles";

const MyBalance = ({ navigation, route }) => {
    const data = [
        {
            value: 70,
            svg: { fill: 'url(#grad1)' },
        },
        {
            value: 30,
            svg: { fill: 'rgba(35, 35, 35, 0.6)' },
        },
    ];

    const Gradient1 = () => (
        <Defs key={'grad1'}>
            <LinearGradient id={'grad1'} x1={'0%'} y={'0%'} x2={'0%'} y2={'90%'}>
                <Stop offset={'-54.97%'} stopColor={'#1F26BF'} />
                <Stop offset={'120.97%'} stopColor={'#196059'} />
            </LinearGradient>
        </Defs>
    );


    const [uri, setUri] = useState('');
    const [qtd, setQtd] = useState(1);
    const [nameToken, setNameToken] = useState('GPX TOKEN');
    const [valueToken, setValueToken] = useState(1);
    const [saldo, setSaldo] = useState(0);
    const [validade, setValidade] = useState(false);


    useEffect(() => {
        getDataCoin();
        getBalanceCoin();

        route.params.qtd ? setQtd(route.params.qtd) : setQtd(1)
    }, []);

    const getDataCoin = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        const idCoin = await AsyncStorage.getItem('id_coin');

        api.get(`/actives/${idCoin}`, { headers: { 'Authorization': `Bearer ${token}` } })
            .then((res) => {
                // console.log(res.data)
                setNameToken(res.data.actives[0].name_token)
                setUri(`https://filesgpx.s3.us-east-2.amazonaws.com/${res.data.actives[0].path}`)

                res.data.actives[0].type_value == "Valor Fixo" ?
                    setValueToken(res.data.actives[0].single_value)
                    : setValueToken(res.data.actives[0].total_value_token)

            })
            .catch((error) => {
                console.log(error);
            })
    }

    const getBalanceCoin = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        api.get('balanceGpxcoin', { headers: { 'Authorization': `Bearer ${token}` } })
            .then((res) => {
                //console.log(res.data)
                if (res.data.balance[0]?.available_balance) {
                    setSaldo(res.data.balance[0].available_balance);
                } else {
                    setSaldo(res.data.balance[0].saldo);
                }

            })
            .catch((error) => {
                console.log("erro1", error);
            })
    }

    useEffect(() => {
        if (saldo > (valueToken * qtd) && saldo != 0)
            setValidade(true);
    }, [saldo, qtd, valueToken]);



    return (
        <>
            <HeaderDefault title={<FormattedMessage id='myBalance.headerMeuSaldo'/>} />

            <View style={styles.container}>
                <Text style={styles.titlePage}><FormattedMessage id='myBalance.saldoDisponivel'/></Text>

                <View style={styles.contentCard}>

                    <View style={styles.contentGraphic}>
                        <PieChart style={{ height: 140 }}
                            data={data}
                            endAngle="70"
                            startAngle={0}
                            padAngle={0}
                            innerRadius={'78%'}
                            outerRadius={'95%'}
                        >
                            <Gradient1 />
                        </PieChart>
                        <View style={styles.contentAmountCoins}>
                            <Text style={styles.valueCoin}><FormattedMessage id='myBalance.txtGpx'/> {saldo}</Text>
                            <View style={styles.hrGraphic} />
                            <Text style={styles.valueCoin}><FormattedMessage id='myBalance.txtBrl'/> {saldo}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.hr} />

                <View style={styles.contentPurchase}>
                    <Text style={styles.textInfoPurchase}><FormattedMessage id='myBalance.valorCompra'/></Text>
                    <Text style={styles.coinPurchase}>{qtd * valueToken} <FormattedMessage id='myBalance.txtBrl'/></Text>
                </View>

                <View style={styles.contentImgCoin}>
                    <Image source={{ uri: uri }} style={styles.imgCoin} />
                </View>

                <Text style={styles.nameCoin}>{nameToken}</Text>
                <Text style={styles.priceCoin}>{valueToken}<FormattedMessage id='myBalance.txtBrl'/></Text>

                <Text style={styles.amountCoin}>
                <FormattedMessage id='myBalance.quantidade'/> <Text style={styles.amountCoinBold}>{qtd}</Text>
                </Text>
            </View>
            {validade ?
                <Button route={"ConfirmPassword"} text={<FormattedMessage id='myBalance.btnContinuar'/>} props={{ qtd: qtd, valueToken: valueToken }} titlePage={<FormattedMessage id='myBalance.btnConfirmaCompra'/>} />
                :
                <Button route={"PaymentMethod"} text={<FormattedMessage id='myBalance.btnSaldoInsuficiente'/>} />
            }

        </>
    );
}

export default MyBalance;